import cx from 'classnames';
import type { FunctionComponent, CSSProperties } from 'react';

type Props = {
  //  If there should be any vertical padding. This is useful when wrapping FallbackImages
  hasPadding?: boolean;
  //  If the list container should have "overflow: auto" (enables internal scrolling)
  hasOverflowAuto?: boolean;
  //  Set your own max-height
  maxHeight?: CSSProperties['maxHeight'];
};

/**
 * ListBody is a scrollable "body" section of the list.
 * It provides a sensible, generic max-height so that the content will
 * scroll but the header can remain at the top. Optionally you
 * can provide any valid maxHeight CSS value as a prop.
 *
 * If you want an unbounded list/infinite height, simply don't use
 * this component/render your list items right below your Header
 */
const ListBody: FunctionComponent<Props> = ({ children, maxHeight, hasPadding, hasOverflowAuto }) => (
  <div
    className={cx('fossa-list__body', {
      'fossa-list__body--padded': hasPadding,
      'fossa-list__body--overflow-auto': hasOverflowAuto,
    })}
    style={maxHeight ? { maxHeight } : undefined}
  >
    {children}
  </div>
);

export default ListBody;
